import { format, isValid, parse } from 'date-fns';

const DATE_ONLY_FORMAT = 'yyyy-MM-dd';
const DISPLAY_FORMAT = 'dd.MM.yyyy';
const EMPTY_DATE_FALLBACK = '01.01.2024';

const toDatePart = value =>
	typeof value === 'string' ? value.split('T')[0] : '';

const parseDatePart = value =>
	parse(toDatePart(value), DATE_ONLY_FORMAT, new Date());

const toTime = date => (date && isValid(date) ? date.getTime() : 0);

/**
 * Format a date-only string (YYYY-MM-DD or ISO with time) to DD.MM.YYYY.
 * Parses as calendar date only to avoid timezone shifts
 * (e.g. date-only strings parsed as UTC midnight show as previous day in USA).
 * Returns the input unchanged when it is not a recognised date.
 */
export function formatDateOnlyToDDMMYYYY(dateString) {
	if (!dateString) return EMPTY_DATE_FALLBACK;
	const date = parseDatePart(dateString);
	return isValid(date) ? format(date, DISPLAY_FORMAT) : dateString;
}

/**
 * Return current local date as YYYY-MM-DD (for date inputs). Avoids toISOString() which uses UTC.
 */
export function getLocalDateString(d = new Date()) {
	return format(d, DATE_ONLY_FORMAT);
}

/**
 * Parse a date-only string (YYYY-MM-DD or ISO) as local calendar date (no timezone shift).
 * Use when you need a Date for toLocaleDateString or other date logic.
 */
export function parseDateOnlyToLocalDate(dateString) {
	if (!dateString) return null;
	const date = parseDatePart(dateString);
	return isValid(date) ? date : new Date(dateString); // fallback for other formats
}

const calendarDateSortTime = transactionDate =>
	toTime(parseDateOnlyToLocalDate(transactionDate));

const createdAtSortTime = createdAt =>
	toTime(createdAt ? new Date(createdAt) : null);

/** Matches backend ORDER BY date DESC, created_at DESC. */
export function compareTransactionsNewestFirst(a, b) {
	const dateA = calendarDateSortTime(a.transactionDate);
	const dateB = calendarDateSortTime(b.transactionDate);
	if (dateB !== dateA) return dateB - dateA;
	const createdA = createdAtSortTime(a.createdAt);
	const createdB = createdAtSortTime(b.createdAt);
	if (createdB !== createdA) return createdB - createdA;
	return String(b.id).localeCompare(String(a.id));
}

export function sortTransactionsNewestFirst(items) {
	return [...items].sort(compareTransactionsNewestFirst);
}
